import { getScaleFactor, getScreenTop } from 'src/lib/utils';
import uiConfig from 'src/lib/ui/config';
import { View } from '@play-co/timestep-core/ui';
import StateObserver from 'src/StateObserver';
import { Transition, TransitioningScene } from 'src/game/logic/SceneManager';
import { isEntity } from '../logic/EntityManager';
import { createEmitter } from 'src/lib/Emitter';

export default abstract class ResponsiveScene implements TransitioningScene {
  getView = () => this.scene;

  protected constructor(private scene: View) {
    const initialHeight = scene.style.height;

    // Resize the scene on added
    scene.on('ViewAdded', () => this.resize());

    scene.once('ViewAdded', () => {
      const { height } = StateObserver.getState().ui.screenSize;
      const heightScalar = height / initialHeight;
      scene.getSubviews().forEach((child) => {
        if (!isEntity(child)) {
          child.style.y *= heightScalar;
        }
      });
    });

    // Resize the scene whenever screen size changes
    createEmitter(this.scene, ({ ui }) => ui.screenSize).addListener(() => {
      this.resize();
    });
  }

  /**
   * Resize function for both ViewAdded and screen size change events
   */
  protected resize() {
    this.scene.updateOpts({
      width: uiConfig.width,
      height: StateObserver.getState().ui.screenSize.height,
      x: 0,
      y: 0,
      offsetY: getScreenTop(),
      clip: true,
    });
  }

  public onBeforeTransition() {}

  public showScene() {}

  public hideScene() {}

  public transition(): Transition {
    return 'fade';
  }
}
